const deliveryDateInput = document.getElementById('delivery_date_input');
const deliveryTimeInput = document.getElementById('delivery_time');

function postData() {
  const deliveryDateInputValue = deliveryDateInput.value;
  const deliveryTimeInputValue = deliveryTimeInput.value;
  const attributes = {
    attributes: {
	        'お届け希望日': deliveryDateInputValue,
	        '配送時間指定': deliveryTimeInputValue
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(attributes),
  })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

deliveryTimeInput.addEventListener('change', postData);